module.exports = __webpack_public_path__ + "frontend/img/bar.beffd146.svg";